<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      config: [],
    };
  },
};
</script>

<style>
@font-face {
  font-family: "Raleway-swap";
  font-display: swap;
  font-style: normal;
  font-weight: 400;
  src: local("Raleway"), local("Raleway-Regular"),
    url(https://fonts.gstatic.com/s/raleway/v12/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2)
      format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

.logo-home,
.logo-home {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}


body {
  background: #f5f7fa;
  letter-spacing: 0.3px;
  font-size: 15px;
  font-family: 'Zen Kaku Gothic New', 'Raleway-swap', sans-serif;
  color: #333;
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100vh;
}

.wrapper {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.text-copy {
  font-size: 12px;
  color: rgba(255,255,255,0.8);
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 10px;
  transform: none;
  z-index: 10;
  pointer-events: none;
}

a {
  text-decoration: none;
  color: #1565C0;
}

a:hover {
  text-decoration: none;
  color: #0D47A1;
}

/* Reset for better compatibility */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Global font settings */
h1, h2, h3, h4, h5, h6, .title, .card-title, .nav-title, .section-title {
  font-family: 'Zen Kaku Gothic New', sans-serif;
  font-weight: 500;
}

/* Override Materialize CSS default colors */
nav, .nav-wrapper, .sidenav, .navbar, .side-nav {
  background-color: #132f53 !important;
}

.nav-wrapper .brand-logo,
.sidenav .brand-logo {
  color: #fff !important;
}

/* Override red/pink default color */
.nav-wrapper ul a,
.sidenav li a,
.sidenav li a i,
.sidenav li a i.material-icons,
.sidenav .subheader {
  color: #fff !important;
}

/* Override the nav hover color */
nav ul a:hover,
.sidenav li > a:hover,
.sidenav li > a.active {
  background-color: rgba(21, 101, 192, 0.15) !important;
}

/* Override dropdown colors */
.dropdown-content {
  background-color: #0d233e !important;
}

.dropdown-content li > a, 
.dropdown-content li > span {
  color: #fff !important;
}

.dropdown-content li:hover, 
.dropdown-content li:active {
  background-color: rgba(21, 101, 192, 0.15) !important;
}

/* Fix accent colors */
.btn, .btn-large, .btn-small,
.btn-floating {
  background-color: #1565C0 !important;
}

/* Fix tab colors */
.tabs .tab a,
.tabs .tab a:hover,
.tabs .tab a.active {
  color: #1565C0 !important;
}

.tabs .indicator {
  background-color: #1565C0 !important;
}

#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

@media (max-width: 768px) {
  .wrapper {
    padding: 35px 25px;
  }

  .logo-home .top-logo {
    max-width: 200px !important;
  }

  .text-copy {
    font-size: 11px;
  }

  .center-box {
    margin-top: 100px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue